import Text from 'components/Text/Text';
import React from 'react';
import { Checkbox, Form } from 'antd';

interface IIsRestrictedCheckBox {
	toggleIsRestricted: () => void;
	isRestricted: boolean;
}

const IsRestrictedCheckBox: React.FC<IIsRestrictedCheckBox> = ({ toggleIsRestricted, isRestricted }) => (
	<Form.Item name="isRestricted" data-test="IsRestrictedCheckBox">
		<Checkbox checked={isRestricted} onChange={toggleIsRestricted}>
			<Text translationNameSpace="form" translationKey="isRestrictedLabel" asFragment={true} />
		</Checkbox>
	</Form.Item>
);

export default React.memo(IsRestrictedCheckBox);
